import React, { useEffect, useState } from 'react';
import './EditHistoryModal.css';
import { toast } from 'react-toastify';
import axios from 'axios';
import LogLoader from '../../LogLoader/LogLoader';


const EditHistoryModal = ({ entryId, onClose, apiUrl }) => {
  const [logs, setLogs] = useState([]);
  const [createdBy, setCreatedBy] = useState(null);
  const [createdAt, setCreatedAt] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchLogs = async () => {
      try {
        const res = await axios.get(`${apiUrl}/${entryId}/logs`);
        setLogs(res.data.logs || []);
        setCreatedBy(res.data.createdBy?.name || 'Unknown');
        setCreatedAt(res.data.createdAt || null);
      } catch (err) {
        toast.error("Failed to load logs.");
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchLogs();
  }, [entryId, apiUrl]);

  return (
    <div className="log-modal-overlay">
      <div className="log-modal">
        <h3>Edit History</h3>
        <button className="close-btn" onClick={onClose}>×</button>

        {loading ? (
          <LogLoader />
        ) : (
          <>

            <div className="log-scroll-container">
              {logs.length === 0 ? (
                <p>No edit history found.</p>
              ) : (
                <ul className="log-list">
                  {[...logs].reverse().map((log, index) => (
                    <li key={index} className="log-entry">
                      <p><strong>Edited By:</strong> {log.editedBy?.name || log.editedBy}</p>
                      <p><strong>Time:</strong> {new Date(log.editedAt).toLocaleString()}</p>
                      <div className="log-changes">
                      {Object.entries(log.changes || {}).map(([field, { old, new: newVal }]) => {
  const formatValue = (val) => {
    if (val === null || val === undefined) return '';
    
    // Array of values (e.g., users or IDs)
    if (Array.isArray(val)) {
      return val.map(item => {
        if (typeof item === 'object') {
          return item.name || item.userId || item._id || '[Object]';
        }
        return item;
      }).join(', ');
    }

    // Single object (e.g., user object)
    if (typeof val === 'object') {
      return val.name || val.userId || val._id || JSON.stringify(val);
    }

    return String(val);
  };

  return (
    <p key={field}>
      <strong>{field}</strong>: "{formatValue(old)}" → "{formatValue(newVal)}"
    </p>
  );
})}

                      </div>
                    </li>
                  ))}
                </ul>
              )}
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default EditHistoryModal;
